import { Box, Grid, SxProps, Theme, Typography } from '@mui/material'
import { Archive } from 'react-feather'
import { boxContainerStyle, subtitleStyle, titleStyle } from './CampaignPreviewCard.styles'
import { StatusChip } from '../StatusChip/StatusChip'
import { useNavigate } from 'react-router-dom'

type CampaignPreviewCardProps = {
	campaignId: string
	title: string
	leads: string
	timeAgo?: string
	status: 'IN_PROGRESS' | 'COMPLETED' | 'WAITING'
	campaignType: string
	sx: SxProps<Theme>
}

export default function CampaignPreviewCard({
	campaignId,
	title,
	leads,
	timeAgo,
	status,
	campaignType,
	sx = {},
}: CampaignPreviewCardProps) {
	const navigate = useNavigate()
	return (
		<Box sx={{ width: '100%', ...sx }}>
			<Grid container sx={boxContainerStyle}>
				<Grid
					item
					xs={1}
					sx={{
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'center',
						alignItems: 'flex-start',
					}}
				>
					<Archive />
				</Grid>
				<Grid item xs={11}>
					<Box>
						<Typography sx={titleStyle} onClick={() => navigate(`/campaign-details/${campaignId}`)}>
							{title}
						</Typography>
						<Typography sx={subtitleStyle}>
							{leads && <span>{leads} ▪ </span>}
							{timeAgo && <span>{timeAgo} ▪ </span>}
							{campaignType && <span>{campaignType} ▪ </span>}
							<StatusChip status={status} />
						</Typography>
					</Box>
				</Grid>
			</Grid>
		</Box>
	)
}
